import "./FormField.scss"

import React from "react"

const FormField = ({ label, isRequired, children, className, id, iconClass, dataTip, dataTestId }) => {
  className = className ? `FormField ${className}` : "FormField"
  return (
    <fieldset className={className} id={id} data-testid={dataTestId || label}>
      {label && (
        <label data-tip={dataTip}>
          <span className={dataTip && "underline"}>{label}</span>
          {isRequired && " *"}
          {iconClass && <i className={iconClass} />}
        </label>
      )}
      {children}
    </fieldset>
  )
}

export default FormField
